// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --hover-background: rgba(0, 36, 117, 0.05);
    --positive-color: #16c784;
    --negative-color: #ea3943;
    --row-background: rgba(255, 255, 255, 0.02);
    --border-color: #e1e5eb;
    --card-background-color: #ffffff;
    --text-color: #000000;
    --header-color: #002475;
    --search-border: #002475;
}

.holder-trends {
    padding: 20px;
    background-color: #f5f6fa;
    color: var(--text-color);
    min-height: 100vh;
    font-family: var(--app-font-family);
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
}


.holder-trends h1 {
    font-size: 24px;
    color: var(--header-color);
    text-align: center;
    margin-bottom: 30px;
    font-family: var(--app-font-family);
    font-weight: 600;
}

/* Controls and search container */
.controls-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto 20px auto;
    max-width: 1400px;
    padding: 0 20px;
    gap: 20px;
}

.stats-summary {
    color: var(--text-color);
    font-size: 14px;
    font-family: monospace;
    white-space: nowrap;
}

.search-container {
    position: relative;
    width: 300px;
    margin-left: auto;
    /* This will push the search to the right */
}

.search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--header-color);
    width: 20px;
    height: 20px;
}

.search-input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    background-color: var(--card-background-color);
    color: var(--text-color);
    font-size: 14px;
    font-family: var(--app-font-family);
}

.search-input:focus {
    outline: none;
    border-color: var(--header-color);
}

.search-input::placeholder {
    color: #6b7280;
}

.section-title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 15px;
    color: var(--text-color);
}

.trends-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
}

.trends-card {
    border: 1px solid black;
    background-color: white;
    overflow: hidden;
    padding-bottom: 10px;
}

.table-header {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr;
    padding: 12px 16px;
    font-weight: 500;
    border-bottom: 1px solid black;
    background-color: var(--card-background-color);
}

.table-header-cell {
    color: black;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
}

.table-header-cell:not(:first-child) {
    justify-content: flex-end;
}

.table-header-cell .sort-icon {
    width: 14px;
    height: 14px;
    opacity: 0.5;
}

.table-header-cell:hover .sort-icon {
    opacity: 1;
}

.token-row {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr;
    padding: 12px 16px;
    border-bottom: 1px solid black;
    font-family: monospace;
    cursor: pointer;
}

.token-row:hover {
    background-color: var(--hover-background);
}

.token-name {
    color: var(--text-color);
    font-weight: 500;
}

.token-holders,
.token-change,
.token-percent {
    text-align: right;
}

.positive {
    color: var(--positive-color);
}

.negative {
    color: var(--negative-color);
}

/* Empty state */
.token-row .zero {
    color: var(--text-color);
    opacity: 0.5;
}

.no-results {
    padding: 20px;
    text-align: center;
    color: var(--text-color);
    opacity: 0.7;
    border-bottom: 1px solid black;
}

/* Loading spinner */
.loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top-color: var(--header-color);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 100px auto;
}

.pagination-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    margin-top: 10px;
}

.pagination-info {
    font-size: 0.875rem;
    font-family: monospace;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pagination-controls {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}
.pagination-button {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.375rem;
    background: white;
    cursor: pointer;
    transition: all 0.2s;
}
.pagination-button:hover {
    background: #f8fafc;
}
.pagination-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
.page-info {
    font-size: 0.875rem;
    color: #64748b;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Responsive design */
@media (max-width: 768px) {

    .controls-container {
        flex-direction: column;
        align-items: stretch;
        padding: 0 15px;
    }

    .search-container {
        width: 100%;
        margin-left: 0;
    }

    .search-input {
        width: 100%;
    }

    .trends-container {
        grid-template-columns: 1fr;
        padding: 0 15px;
    }


    .controls-container {
        flex-direction: column;
        gap: 15px;
    }


    .token-row,
    .table-header {
        font-size: 14px;
        padding: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/holder_trends.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,yBAAyB;IACzB,yBAAyB;IACzB,2CAA2C;IAC3C,uBAAuB;IACvB,gCAAgC;IAChC,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,wBAAwB;IACxB,iBAAiB;IACjB,mCAAmC;IACnC,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;;AAGA;IACI,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,0BAA0B;IAC1B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,8CAA8C;IAC9C,wBAAwB;IACxB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,kBAAkB;IAClB,8BAA8B;IAC9B,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA,gBAAgB;AAChB;IACI,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;IACZ,8BAA8B;AAClC;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,sBAAsB;AACtB;;IAEI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;QAC1B,eAAe;IACnB;;;IAGA;QACI,sBAAsB;QACtB,SAAS;IACb;;;IAGA;;QAEI,eAAe;QACf,aAAa;IACjB;AACJ","sourcesContent":[":root {\n    --hover-background: rgba(0, 36, 117, 0.05);\n    --positive-color: #16c784;\n    --negative-color: #ea3943;\n    --row-background: rgba(255, 255, 255, 0.02);\n    --border-color: #e1e5eb;\n    --card-background-color: #ffffff;\n    --text-color: #000000;\n    --header-color: #002475;\n    --search-border: #002475;\n}\n\n.holder-trends {\n    padding: 20px;\n    background-color: #f5f6fa;\n    color: var(--text-color);\n    min-height: 100vh;\n    font-family: var(--app-font-family);\n    width: 100%;\n    max-width: 100%;\n    overflow-x: hidden;\n}\n\n\n.holder-trends h1 {\n    font-size: 24px;\n    color: var(--header-color);\n    text-align: center;\n    margin-bottom: 30px;\n    font-family: var(--app-font-family);\n    font-weight: 600;\n}\n\n/* Controls and search container */\n.controls-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0 auto 20px auto;\n    max-width: 1400px;\n    padding: 0 20px;\n    gap: 20px;\n}\n\n.stats-summary {\n    color: var(--text-color);\n    font-size: 14px;\n    font-family: monospace;\n    white-space: nowrap;\n}\n\n.search-container {\n    position: relative;\n    width: 300px;\n    margin-left: auto;\n    /* This will push the search to the right */\n}\n\n.search-icon {\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--header-color);\n    width: 20px;\n    height: 20px;\n}\n\n.search-input {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid var(--border-color);\n    border-radius: 6px;\n    background-color: var(--card-background-color);\n    color: var(--text-color);\n    font-size: 14px;\n    font-family: var(--app-font-family);\n}\n\n.search-input:focus {\n    outline: none;\n    border-color: var(--header-color);\n}\n\n.search-input::placeholder {\n    color: #6b7280;\n}\n\n.section-title {\n    font-size: 18px;\n    font-weight: 500;\n    margin-bottom: 15px;\n    color: var(--text-color);\n}\n\n.trends-container {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 0 20px;\n}\n\n.trends-card {\n    border: 1px solid black;\n    background-color: white;\n    overflow: hidden;\n    padding-bottom: 10px;\n}\n\n.table-header {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1fr 1fr;\n    padding: 12px 16px;\n    font-weight: 500;\n    border-bottom: 1px solid black;\n    background-color: var(--card-background-color);\n}\n\n.table-header-cell {\n    color: black;\n    cursor: pointer;\n    user-select: none;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.table-header-cell:not(:first-child) {\n    justify-content: flex-end;\n}\n\n.table-header-cell .sort-icon {\n    width: 14px;\n    height: 14px;\n    opacity: 0.5;\n}\n\n.table-header-cell:hover .sort-icon {\n    opacity: 1;\n}\n\n.token-row {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1fr 1fr;\n    padding: 12px 16px;\n    border-bottom: 1px solid black;\n    font-family: monospace;\n    cursor: pointer;\n}\n\n.token-row:hover {\n    background-color: var(--hover-background);\n}\n\n.token-name {\n    color: var(--text-color);\n    font-weight: 500;\n}\n\n.token-holders,\n.token-change,\n.token-percent {\n    text-align: right;\n}\n\n.positive {\n    color: var(--positive-color);\n}\n\n.negative {\n    color: var(--negative-color);\n}\n\n/* Empty state */\n.token-row .zero {\n    color: var(--text-color);\n    opacity: 0.5;\n}\n\n.no-results {\n    padding: 20px;\n    text-align: center;\n    color: var(--text-color);\n    opacity: 0.7;\n    border-bottom: 1px solid black;\n}\n\n/* Loading spinner */\n.loading-spinner {\n    width: 40px;\n    height: 40px;\n    border: 3px solid #f3f3f3;\n    border-top-color: var(--header-color);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin: 100px auto;\n}\n\n.pagination-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px;\n    margin-top: 10px;\n}\n\n.pagination-info {\n    font-size: 0.875rem;\n    font-family: monospace;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.pagination-controls {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n.pagination-button {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 1rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 0.375rem;\n    background: white;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n.pagination-button:hover {\n    background: #f8fafc;\n}\n.pagination-button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n.page-info {\n    font-size: 0.875rem;\n    color: #64748b;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n\n    .controls-container {\n        flex-direction: column;\n        align-items: stretch;\n        padding: 0 15px;\n    }\n\n    .search-container {\n        width: 100%;\n        margin-left: 0;\n    }\n\n    .search-input {\n        width: 100%;\n    }\n\n    .trends-container {\n        grid-template-columns: 1fr;\n        padding: 0 15px;\n    }\n\n\n    .controls-container {\n        flex-direction: column;\n        gap: 15px;\n    }\n\n\n    .token-row,\n    .table-header {\n        font-size: 14px;\n        padding: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
